export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5231.410b49cd.jpg";